import {
  CONTACTS_DOCUMENT_LIST,
  CONTACTS_DOCUMENT_FILTER,
  CONTACTS_DOCUMENT_CREATE,
  CONTACTS_DOCUMENT_CREATE_SUCCESS,
  CONTACTS_DOCUMENT_LIST_SUCCESS,
  CONTACTS_DOCUMENT_REQUEST_FAILED,
  CONTACTS_DOCUMENT_UPDATE,
  CONTACTS_DOCUMENT_UPDATE_SUCCESS,
  CONTACTS_DOCUMENT_DELETE,
  CONTACTS_DOCUMENT_DELETE_SUCCESS,
} from "./actionTypes";

const initialState = {
  contactsDocument: [],
  contactsDocumentCreated: {},
  contactsDocumentUpdated: {},
  contactsDocumentDeleted:false,
  loading: false,
  error: "",
};

const contactsDocument = (state = initialState, action) => {
  switch (action.type) {
    case CONTACTS_DOCUMENT_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONTACTS_DOCUMENT_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONTACTS_DOCUMENT_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONTACTS_DOCUMENT_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONTACTS_DOCUMENT_DELETE:
        state = {
          ...state,
          loading: true,
          contactsDocumentDeleted: false,
        };
        break;
    case CONTACTS_DOCUMENT_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        contactsDocumentCreated: action.payload,
        error: "",
      };
      break;
    case CONTACTS_DOCUMENT_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        contactsDocument: action.payload,
        contactsDocumentCreated: {},
        contactsDocumentUpdated: {},
        contactsDocumentDeleted: false,
        error: "",
      };
      break;
    case CONTACTS_DOCUMENT_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        contactsDocumentUpdated: action.payload,
        error: "",
      };
      break;
    case CONTACTS_DOCUMENT_DELETE_SUCCESS:
      state = {
        ...state,
        loading: false,
        contactsDocumentDeleted: true,
        error: "",
      };
      break;
    case CONTACTS_DOCUMENT_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default contactsDocument;
